import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { gasCheckDate } from '../gas-datepicker-directive/datepicker.helper';

const PATTERN = /[0-9]{2}[.][0-9]{2}[.][0-9]{4}/;

@Pipe({
  name: 'gasDate',
  pure: true,
})
export class GasDatePipe implements PipeTransform {

  constructor(
    private datePipe: DatePipe,
  ) {}

  public transform(value: string | Date, format: string = 'dd.MM.yyyy') {
    try {
      let currentDate: string;
      /** дата представлена в виде Object Date */
      if (typeof value === 'object') {
        /** возвращаем дату в нужном нам формате */
        return this.datePipe.transform(value, format);
      } else if (typeof value === 'string') {
        currentDate = value;
      }
      /** проверяем дату на правильный формат ввода */
      if (PATTERN.test(currentDate)) {
        /** проверяем что дата существует */
        if (gasCheckDate(currentDate)) {
          /** возвращаем дату */
          return currentDate;
        } else {
          /** возвращаем текущее value если даты не существует */
          return value;
        }
      } else {
        /** возвращаем текущее value */
        return value;
      }
    } catch (e) {}
  }
}
